export const REVIEWS_POPUPS = {
    BBB: 'bbb',
    BIZRATE: 'bizrate',
    GOOGLE: 'google',
    RESELLER: 'reseller',
    SITEJABBER: 'sitejabber',
    TRUST_PILOT: 'trustpilot',
} as const;

export const INSTANT_FEEDBACK_WIDGET_ID = 'InstantFeedbackWidget';

export const REVIEWS_POPUPS_SRC = {
    BIZRATE: '//eval.bizrate.com/js/pos_198649.js',
    RESELLER: 'https://www.resellerratings.com/popup/include/popup.js',
    SITEJABBER: 'https://biz.sitejabber.com/js/widget.min.1585162550.js',
};
